import RightTimeApi from "@/API";

export type KpsiCompanyOption = { id: number; name: string };

export type KpsiBootstrap = {
  isAdmin: boolean;
  companies: KpsiCompanyOption[];
  stageNames: string[];
  permissions: Record<string, { scorer: boolean; interpreter: boolean }>;
};

export async function kpsiGet<T>(url: string): Promise<T> {
  const resp = await RightTimeApi.getAsync(url);
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || `KPSI request failed: ${url}`);
  }
  return resp.jsonData as T;
}

export async function kpsiPost<T>(url: string, body?: unknown): Promise<T> {
  const resp = await RightTimeApi.postAsync(url, body ?? {});
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || `KPSI request failed: ${url}`);
  }
  return resp.jsonData as T;
}

const COMPANY_KEY = "kpsi_company";

export function readSavedCompanyId(): number | null {
  const raw = window.localStorage.getItem(COMPANY_KEY);
  const n = raw ? Number(raw) : NaN;
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function saveCompanyId(id: number) {
  window.localStorage.setItem(COMPANY_KEY, String(id));
}
